import React from 'react';

import * as S from './style';

interface IProps {
  children?: React.ReactNode;
  className?: string;
}

const MegaPromotionTemplate = ({ children, className }: IProps) => (
  <S.MegaPromotionTemplate className={className}>
    {children}
  </S.MegaPromotionTemplate>
);

export default MegaPromotionTemplate;
